import React from "react";

export const ReferalsHistoryBottomBg = () => {
  return (
    <svg viewBox="0 0 353 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M284 13L288.775 8.41967H305.511L312.202 2H341L333.412 9.27323L329.53 13H284Z"
        fill="#2A1E54"
      />
      <path
        d="M69 13L64.2254 8.41967H47.4894L40.7979 2H12L19.5883 9.27323L23.4702 13H69Z"
        fill="#2A1E54"
      />
      <path
        d="M309 2L305.168 5.66667H286.002L278.334 13H217L220.834 9.33334H278.334L286.002 2H309Z"
        fill="#7F5CFF"
      />
      <path
        d="M44 2L47.8317 5.66667H66.9984L74.666 13H136L132.166 9.33334H74.666L66.9984 2H44Z"
        fill="#7F5CFF"
      />
      <rect
        x="177"
        y="0.707107"
        width="17"
        height="17"
        transform="rotate(45 177 0.707107)"
        fill="url(#paint0_radial_2047_13392)"
        stroke="#7F5CFF"
      />
      <path
        d="M176.938 7.05218C176.91 7.08176 176.559 7.44518 176.156 7.85932C175.753 8.27345 175.317 8.72281 175.187 8.85803C175.058 8.99326 174.826 9.23414 174.67 9.39331C174.517 9.55248 174.261 9.81449 174.103 9.97789C173.776 10.316 173.796 10.2948 173.011 11.1034C172.113 12.0274 172 12.1444 172 12.157C172 12.1627 172.782 12.1683 173.737 12.1683H175.475V15.0841V18H175.701H175.93L175.938 17.8408C175.944 17.7549 175.948 16.3308 175.948 14.6799V11.6753L174.749 11.6725L173.551 11.6682L173.966 11.2457C174.194 11.0132 174.616 10.5892 174.903 10.3019L175.427 9.78068L175.5 9.85816L175.575 9.93563L176.286 9.23132L176.996 8.52701L177.489 9.0158C177.999 9.51868 178.566 10.0962 178.772 10.3188L178.89 10.4456L178.836 10.4977L178.781 10.5498L178.438 10.2005C178.25 10.0089 177.94 9.69616 177.749 9.506C177.558 9.31584 177.312 9.06933 177.202 8.95805L177.002 8.75661L176.731 9.02848C176.58 9.17779 176.169 9.58629 175.816 9.93563L175.174 10.5695L175.097 10.4949L175.021 10.4202L174.936 10.5089C174.89 10.5582 174.649 10.7991 174.402 11.0442C174.155 11.2893 173.953 11.4936 173.953 11.4978C173.953 11.502 174.436 11.5062 175.029 11.5062H176.106L176.109 14.7489L176.113 17.993L176.484 17.9972L176.853 18V17.0633V16.1265L177.073 15.904C177.193 15.7828 177.338 15.6335 177.396 15.5729L177.499 15.4645V13.5938L177.497 11.7246L177.427 11.6922C177.325 11.6457 177.278 11.564 177.286 11.4513C177.291 11.3879 177.302 11.3555 177.332 11.3175C177.38 11.2555 177.466 11.2104 177.538 11.2104C177.588 11.209 177.608 11.1949 177.772 11.04L177.951 10.871L178.273 11.1879L178.594 11.5062H179.317C179.714 11.5062 180.04 11.502 180.04 11.4964C180.04 11.4908 179.915 11.3626 179.763 11.2104C179.611 11.0597 179.327 10.7738 179.13 10.5766C178.933 10.3793 178.705 10.1511 178.623 10.068L178.474 9.92014L178.53 9.86238L178.587 9.80463L178.872 10.0878C179.028 10.2441 179.295 10.5118 179.466 10.6822C179.635 10.8526 179.921 11.1386 180.102 11.3175C180.281 11.4964 180.428 11.6513 180.428 11.6598C180.428 11.6711 180.108 11.6753 179.236 11.6753H178.045V14.8376V18H178.289H178.533V15.0841V12.1683L180.266 12.1655L182 12.1613L181.915 12.0697C181.831 11.9781 181.421 11.5555 181.124 11.2527C181.037 11.1639 180.861 10.9836 180.737 10.8512C180.436 10.5399 179.607 9.68771 179.187 9.2609C179.005 9.07637 178.853 8.92001 178.849 8.91438C178.841 8.90311 178.566 8.61998 178.109 8.15231C177.983 8.02272 177.683 7.71 177.441 7.45927C177.2 7.20713 176.999 7.00006 176.995 7.00006C176.989 6.99865 176.963 7.0226 176.938 7.05218ZM177.037 7.92412C177.055 7.94665 177.295 8.18612 177.572 8.45798C177.848 8.72844 178.073 8.96086 178.073 8.97213C178.073 8.9834 178.05 9.0158 178.022 9.04256L177.97 9.09046L177.486 8.6073L177.002 8.12414L176.818 8.30726C176.718 8.40727 176.501 8.6242 176.337 8.78901L176.04 9.08905L175.98 9.02707L175.92 8.96368L176.067 8.81577C176.148 8.73407 176.385 8.49883 176.594 8.29036C176.804 8.08329 176.978 7.90721 176.979 7.90017C176.988 7.87763 177.001 7.88327 177.037 7.92412ZM177.33 9.56939C177.552 9.79336 177.579 9.8159 177.624 9.8159C177.65 9.8159 177.693 9.82435 177.72 9.83562C177.769 9.85534 177.858 9.94972 177.858 9.98071C177.858 9.99057 178.05 10.1906 178.287 10.4244L178.716 10.8498L178.738 10.8062C178.767 10.754 178.844 10.7061 178.922 10.6949C179.038 10.6766 179.18 10.7695 179.202 10.8794C179.223 10.9921 179.166 11.1161 179.074 11.1583C179.004 11.1921 178.882 11.1893 178.823 11.1541C178.795 11.1372 178.564 10.9217 178.309 10.6723L177.844 10.2202L177.762 10.2948C177.716 10.3357 177.553 10.4934 177.403 10.6456L177.126 10.9217V12.936L177.124 14.9503L177.021 15.0616L176.916 15.1729L176.976 15.2335C177.143 15.3955 177.027 15.6617 176.79 15.6617C176.739 15.6617 176.653 15.6265 176.613 15.5884L176.58 15.5589V15.8786V16.1998L176.617 16.2294C176.665 16.2646 176.724 16.3871 176.722 16.4435C176.721 16.5449 176.659 16.6336 176.561 16.6773C176.485 16.7097 176.431 16.7111 176.358 16.6773C176.248 16.6294 176.181 16.5111 176.201 16.4068C176.223 16.2956 176.294 16.211 176.383 16.1899L176.422 16.1801V13.5361V10.8935L176.886 10.4329C177.14 10.1793 177.364 9.95253 177.383 9.92859L177.416 9.88492L177.246 9.71589L177.075 9.54685L176.933 9.69194C176.856 9.77223 176.672 9.95676 176.524 10.1047C176.378 10.2512 176.243 10.3892 176.224 10.4089L176.192 10.4456L176.241 10.4963C176.3 10.5582 176.329 10.6583 176.309 10.7301C176.289 10.7963 176.227 10.8695 176.169 10.8963C176.122 10.9188 176.121 10.9231 176.121 11.002V11.0837H175.668C175.298 11.0837 175.216 11.0865 175.206 11.1034C175.19 11.1301 175.103 11.178 175.048 11.1893C174.952 11.209 174.827 11.1428 174.784 11.0499C174.693 10.8555 174.866 10.6484 175.073 10.7033C175.15 10.7245 175.223 10.7893 175.253 10.8653L175.278 10.9287H175.612C175.798 10.9287 175.948 10.9231 175.948 10.9174C175.948 10.9104 175.933 10.8963 175.912 10.8865C175.894 10.8766 175.859 10.8428 175.838 10.8118C175.805 10.7653 175.798 10.74 175.798 10.6681C175.798 10.5639 175.832 10.5047 175.933 10.4371C175.989 10.4005 176.336 10.0582 176.916 9.46656C176.995 9.38768 177.064 9.32288 177.071 9.32288C177.078 9.32288 177.195 9.43416 177.33 9.56939Z"
        fill="#C6B7FF"
      />
      <path
        d="M177.538 10.0103C177.489 10.0624 177.518 10.137 177.594 10.1596C177.634 10.1722 177.7 10.1201 177.7 10.075C177.7 9.99898 177.588 9.95531 177.538 10.0103Z"
        fill="#C6B7FF"
      />
      <path
        d="M176.97 10.5836L176.58 10.9709V13.105C176.58 14.4643 176.584 15.2377 176.594 15.232C176.601 15.2278 176.671 15.1546 176.752 15.07L176.895 14.9165V12.9134V10.9104L177.18 10.6272C177.335 10.4709 177.471 10.3385 177.483 10.3314C177.497 10.323 177.487 10.3061 177.44 10.2582C177.405 10.2244 177.374 10.1962 177.368 10.1962C177.364 10.1962 177.184 10.3709 176.97 10.5836Z"
        fill="#C6B7FF"
      />
      <path
        d="M175.992 10.6048C175.954 10.6414 175.956 10.6893 175.993 10.7301C176.032 10.771 176.088 10.7639 176.124 10.716C176.151 10.6822 176.151 10.6766 176.129 10.6372C176.095 10.571 176.039 10.5583 175.992 10.6048Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.953 10.8837C174.919 10.9203 174.923 10.9795 174.96 11.0048C175.006 11.0358 175.052 11.033 175.078 10.9964C175.108 10.9541 175.107 10.9203 175.072 10.8865C175.036 10.8513 174.983 10.8499 174.953 10.8837Z"
        fill="#C6B7FF"
      />
      <path
        d="M178.894 10.8752C178.867 10.902 178.873 10.9766 178.904 11.0048C178.942 11.0386 178.991 11.0288 179.026 10.9809C179.054 10.9442 179.054 10.9386 179.034 10.9034C179.018 10.8752 178.999 10.8639 178.963 10.8611C178.936 10.8583 178.904 10.8654 178.894 10.8752Z"
        fill="#C6B7FF"
      />
      <path
        d="M176.725 15.3433C176.715 15.3546 176.709 15.3841 176.712 15.4109C176.72 15.4982 176.839 15.5208 176.881 15.4433C176.898 15.4109 176.898 15.401 176.878 15.3686C176.86 15.3391 176.841 15.3292 176.798 15.3264C176.762 15.3236 176.736 15.3292 176.725 15.3433Z"
        fill="#C6B7FF"
      />
      <path
        d="M176.386 16.3857C176.338 16.459 176.406 16.552 176.49 16.5252C176.585 16.4942 176.563 16.3632 176.462 16.3548C176.419 16.3505 176.405 16.3562 176.386 16.3857Z"
        fill="#C6B7FF"
      />
      <path
        d="M175.27 7.06486C175.257 7.07613 175.257 7.58464 175.27 7.81988L175.279 8.00018L175.431 7.99596L175.583 7.99173L175.587 7.52266L175.59 7.055H175.435C175.349 7.055 175.274 7.05922 175.27 7.06486Z"
        fill="#C6B7FF"
      />
      <path
        d="M178.406 7.52266L178.41 7.99173L178.572 7.99596L178.733 8.00018V7.52689V7.055H178.568H178.403L178.406 7.52266Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.584 7.21276V7.32263H174.699H174.814V7.21699C174.814 7.14233 174.808 7.11134 174.797 7.11134C174.787 7.11134 174.735 7.10852 174.682 7.10711L174.584 7.10289V7.21276Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.193 7.20853V7.32263H179.308H179.423V7.21699V7.11134H179.331C179.28 7.11134 179.229 7.10711 179.216 7.10289C179.196 7.09584 179.193 7.10993 179.193 7.20853Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.34 7.57759C174.34 7.61563 174.229 7.73536 174.146 7.78889L174.056 7.84805L174.112 7.87763C174.185 7.91566 174.303 8.02976 174.326 8.08329C174.336 8.10724 174.347 8.12555 174.353 8.12555C174.359 8.12555 174.374 8.10442 174.389 8.07766C174.423 8.01568 174.548 7.89172 174.601 7.86918C174.65 7.84805 174.652 7.83819 174.61 7.81988C174.552 7.79452 174.442 7.68888 174.403 7.62408C174.367 7.56492 174.34 7.54379 174.34 7.57759Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.584 7.64521C179.545 7.69874 179.493 7.74804 179.439 7.78326C179.354 7.83679 179.334 7.85792 179.37 7.85792C179.406 7.85932 179.527 7.95934 179.587 8.04104L179.649 8.12415L179.694 8.05512C179.748 7.97342 179.841 7.89172 179.911 7.86214L179.96 7.84101L179.914 7.82129C179.854 7.79734 179.723 7.67479 179.687 7.61141C179.673 7.58464 179.657 7.5621 179.653 7.5621C179.649 7.5621 179.617 7.60014 179.584 7.64521Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.093 8.09034C180.059 8.16077 179.962 8.25937 179.895 8.29177L179.839 8.31995L179.879 8.33544C179.934 8.35798 180.043 8.46926 180.087 8.54533L180.122 8.6059L180.159 8.54533C180.206 8.46644 180.305 8.37347 180.376 8.33967C180.43 8.3129 180.432 8.31149 180.397 8.30163C180.333 8.28191 180.234 8.1988 180.183 8.11992C180.156 8.07766 180.129 8.04245 180.125 8.04104C180.12 8.04104 180.106 8.06358 180.093 8.09034Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.809 8.0734C173.809 8.08185 173.793 8.11988 173.773 8.15792L173.737 8.22412H173.831H173.924L173.881 8.15792C173.856 8.12129 173.838 8.08326 173.838 8.0734C173.838 8.06354 173.832 8.05509 173.823 8.05509C173.816 8.05509 173.809 8.06354 173.809 8.0734Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.153 8.31289C179.088 8.37627 179.035 8.43685 179.035 8.44671C179.035 8.45657 179.195 8.62419 179.391 8.81999C179.586 9.01579 179.795 9.22427 179.854 9.28484L179.961 9.39612L180.086 9.26371L180.212 9.13271L180.093 9.01297C180.027 8.94677 179.864 8.78196 179.729 8.64673C179.595 8.5115 179.44 8.35374 179.387 8.29739C179.334 8.24246 179.285 8.19597 179.281 8.19597C179.275 8.19597 179.219 8.24809 179.153 8.31289Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.471 8.45372C174.34 8.58754 174.149 8.78193 174.048 8.88616C173.944 8.9904 173.806 9.12986 173.742 9.19606L173.623 9.3172L173.736 9.43271C173.798 9.4961 173.854 9.54822 173.861 9.54822C173.868 9.54822 173.92 9.50455 173.974 9.45243C174.083 9.34678 174.757 8.67769 174.89 8.53964L174.974 8.45372L174.857 8.33117C174.793 8.26496 174.732 8.21003 174.722 8.21143C174.714 8.21143 174.6 8.32131 174.471 8.45372Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.816 8.36501C173.723 8.37065 173.692 8.37628 173.71 8.38614C173.744 8.40727 173.794 8.48052 173.814 8.53827L173.832 8.59039L173.881 8.51855C173.906 8.47911 173.954 8.4284 173.985 8.40586C174.017 8.38333 174.034 8.3636 174.023 8.3636C173.967 8.35797 173.935 8.35797 173.816 8.36501Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.048 8.58334C172.977 8.60447 172.901 8.66927 172.865 8.73547C172.854 8.75801 172.841 8.81013 172.837 8.85239C172.812 9.08763 173.053 9.26089 173.275 9.16792C173.401 9.11439 173.478 9.0017 173.478 8.87211C173.478 8.81435 173.433 8.71012 173.388 8.66363C173.309 8.58052 173.164 8.54672 173.048 8.58334Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.739 8.58199C180.654 8.60453 180.592 8.65947 180.548 8.75244C180.505 8.84118 180.505 8.91724 180.548 9.00599C180.588 9.09191 180.628 9.12854 180.72 9.16939C180.842 9.22151 180.994 9.18207 181.085 9.07642C181.284 8.83695 181.048 8.49747 180.739 8.58199Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.256 9.44402L180.138 9.56516L180.178 9.60883C180.201 9.63418 180.31 9.74546 180.422 9.85815C180.667 10.1047 180.998 10.4427 181.1 10.5484L181.173 10.6259L181.298 10.5047C181.392 10.4117 181.419 10.3779 181.41 10.361C181.392 10.33 180.398 9.32288 180.385 9.32288C180.379 9.32288 180.322 9.37781 180.256 9.44402Z"
        fill="#C6B7FF"
      />
      <path
        d="M172.345 9.61451V9.77368H172.503H172.661V9.62014V9.46519L172.503 9.46097L172.345 9.45674V9.61451Z"
        fill="#C6B7FF"
      />
      <path
        d="M181.318 9.61451V9.77368H181.476H181.634V9.62014V9.46519L181.476 9.46097L181.318 9.45674V9.61451Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.097 9.83984C172.639 10.3033 172.575 10.3709 172.575 10.3822C172.575 10.3878 172.626 10.4441 172.69 10.5089L172.804 10.6259L173.25 10.185L173.696 9.74406L173.57 9.61728L173.443 9.4891L173.097 9.83984Z"
        fill="#C6B7FF"
      />
      <path
        d="M172.249 10.7724L172.146 10.8808L172.255 10.9837L172.362 11.0879L172.471 10.9794L172.582 10.8724L172.474 10.7667C172.415 10.709 172.364 10.6611 172.359 10.6625C172.355 10.6625 172.306 10.7132 172.249 10.7724Z"
        fill="#C6B7FF"
      />
      <path
        d="M181.505 10.7667L181.397 10.8724L181.505 10.978L181.613 11.0823L181.725 10.9766L181.838 10.871L181.732 10.7667C181.675 10.709 181.624 10.6611 181.62 10.6611C181.616 10.6611 181.564 10.709 181.505 10.7667Z"
        fill="#C6B7FF"
      />
      <path
        d="M177.845 11.202C177.741 11.3076 177.74 11.3104 177.763 11.3428C177.825 11.4358 177.799 11.5809 177.705 11.6598L177.657 11.702V13.6164V15.5321L177.431 15.7673C177.306 15.8969 177.164 16.0462 177.115 16.1012L177.025 16.1984V17.0985V18H177.262H177.499V17.3675V16.7351L177.463 16.7266C177.398 16.7111 177.328 16.6365 177.305 16.5576C177.286 16.4928 177.285 16.4773 177.305 16.4139C177.316 16.3759 177.344 16.3266 177.365 16.3068C177.408 16.266 177.496 16.2251 177.539 16.2251C177.555 16.2251 177.631 16.1603 177.72 16.0702L177.872 15.9152L177.875 13.7065L177.879 11.4992H178.113C178.241 11.5006 178.346 11.4978 178.346 11.4922C178.344 11.4879 178.255 11.3978 178.148 11.2907L177.951 11.0963L177.845 11.202Z"
        fill="#C6B7FF"
      />
      <path
        d="M177.48 11.4048C177.466 11.4189 177.456 11.4471 177.456 11.4682C177.456 11.509 177.504 11.5626 177.542 11.5626C177.578 11.5626 177.628 11.509 177.628 11.471C177.628 11.3949 177.529 11.3513 177.48 11.4048Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.01 12.7247V12.8445H174.175H174.34V12.7247V12.605H174.175H174.01V12.7247Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.758 12.6304C179.622 12.6937 179.573 12.8543 179.652 12.9825C179.708 13.0727 179.817 13.1093 179.932 13.0769C180.014 13.0543 180.057 13.0163 180.09 12.9403C180.176 12.7374 179.962 12.5374 179.758 12.6304Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.692 12.6303C174.688 12.6345 174.685 12.7162 174.685 12.812V12.9867L174.854 12.9825L175.022 12.9782L175.027 12.7979L175.031 12.6176L174.865 12.6205C174.774 12.6219 174.697 12.6275 174.692 12.6303Z"
        fill="#C6B7FF"
      />
      <path
        d="M178.963 12.8022V12.9853H179.136H179.309L179.305 12.805L179.301 12.6261L179.133 12.6219L178.963 12.6176V12.8022Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.366 12.6993C180.36 12.7035 180.356 12.7768 180.356 12.8613V13.0134H181.124H181.892V12.8514V12.6894H181.134C180.716 12.6894 180.37 12.6937 180.366 12.6993Z"
        fill="#C6B7FF"
      />
      <path
        d="M172.086 12.8585V13.0135H172.629H173.173L173.333 13.1656C173.422 13.2487 173.493 13.3234 173.495 13.3318C173.495 13.3389 173.496 13.7544 173.496 14.2559C173.496 14.7559 173.501 15.1729 173.506 15.1799C173.511 15.187 173.783 15.4603 174.111 15.7871C174.438 16.1139 174.711 16.3942 174.715 16.4125C174.721 16.4294 174.721 16.7942 174.717 17.221L174.71 18H174.86C175.005 18 175.012 17.9986 175.021 17.9676C175.025 17.9507 175.03 17.3999 175.03 16.7421V15.549L174.661 15.5476L174.29 15.5448L174.049 15.3025L173.808 15.0616L173.809 14.139V13.2163L173.557 12.9599L173.303 12.7036H172.695H172.086V12.8585ZM174.843 15.9265V16.0744L174.776 16.0138C174.689 15.9378 174.557 15.7997 174.556 15.7842C174.556 15.7772 174.621 15.7744 174.699 15.7772L174.843 15.78V15.9265Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.232 13.2191C174.192 13.2797 174.066 13.4079 174.02 13.4361L173.979 13.46L174.02 13.4854C174.041 13.4981 174.103 13.5544 174.156 13.6093L174.254 13.7094L174.331 13.6248C174.374 13.5783 174.435 13.5234 174.465 13.5023L174.521 13.4643L174.412 13.3544C174.351 13.2952 174.292 13.2304 174.281 13.2121L174.259 13.1783L174.232 13.2191Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.685 13.4079V13.5769H174.857H175.03V13.4163V13.2557L174.985 13.2473C174.961 13.2431 174.883 13.2388 174.813 13.2388H174.685V13.4079Z"
        fill="#C6B7FF"
      />
      <path
        d="M178.963 13.4107V13.5769H179.136H179.309L179.305 13.4107L179.301 13.2459L179.133 13.2445L178.963 13.2431V13.4107Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.651 13.3431C179.648 13.3459 179.648 13.3811 179.649 13.4192L179.655 13.4896L179.72 13.4952C179.754 13.498 179.786 13.4966 179.79 13.4938C179.793 13.491 179.796 13.4544 179.796 13.4121V13.3375H179.727C179.688 13.3375 179.654 13.3403 179.651 13.3431Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.835 13.8164L179.485 14.1685H179.396H179.308V13.9995V13.8305H179.136H178.963V14.5672V15.3039L179.337 14.9377L179.71 14.5714V14.4714V14.3714L180.013 14.0728L180.316 13.7741H181.104H181.892V13.6192V13.4642H181.039H180.187L179.835 13.8164Z"
        fill="#C6B7FF"
      />
      <path
        d="M172.086 13.6333V13.7882H172.689H173.294L173.29 13.6361L173.285 13.4854L172.687 13.4811L172.086 13.4783V13.6333Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.685 13.9925V14.1545H174.857H175.03V13.9925V13.8305H174.857H174.685V13.9925Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.205 14.1221C174.191 14.1516 174.168 14.17 174.137 14.1756C174.107 14.1826 174.096 14.1911 174.102 14.2066C174.106 14.2179 174.11 14.2517 174.11 14.2826V14.3376H174.229H174.347V14.2841C174.348 14.2559 174.354 14.2207 174.36 14.2066C174.369 14.1883 174.366 14.1826 174.343 14.1826C174.327 14.1826 174.295 14.1601 174.271 14.1305L174.229 14.0784L174.205 14.1221Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.194 14.315C180.09 14.3517 180.04 14.4277 180.04 14.5446V14.6123L179.502 15.1405L178.963 15.6687V16.8337V18H179.114H179.265V16.897V15.7955L179.793 15.2785C180.083 14.9954 180.335 14.7588 180.352 14.7545C180.396 14.7404 180.481 14.6433 180.497 14.5855C180.546 14.4151 180.365 14.2545 180.194 14.315Z"
        fill="#C6B7FF"
      />
      <path
        d="M172.645 14.3404C172.527 14.4066 172.497 14.5672 172.579 14.6883C172.615 14.7404 172.618 14.7573 172.618 14.8841V15.0236L173.364 15.7547L174.111 16.4843V17.2422V18H174.262H174.412V17.1802V16.3604L173.885 15.8406C173.594 15.556 173.258 15.2264 173.139 15.1081L172.919 14.8954V14.8137C172.919 14.7517 172.928 14.7221 172.955 14.6813C172.995 14.6221 173.012 14.5545 173 14.4968C172.965 14.3418 172.781 14.2615 172.645 14.3404Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.886 14.3376C180.824 14.37 180.772 14.4615 180.772 14.5362C180.772 14.563 180.785 14.6123 180.801 14.6461L180.83 14.708L180.795 14.7517C180.775 14.7757 180.501 15.0518 180.185 15.3659L179.611 15.9364L179.609 16.9675V18H179.753H179.897V17.4563V16.9125L180.452 16.3646L181.006 15.8166H181.091H181.174V15.6828V15.549H181.005H180.834L180.369 16.0096L179.904 16.4688L179.899 16.2744L179.895 16.0786L180.507 15.4786L181.117 14.8799V14.8095C181.118 14.7489 181.124 14.732 181.166 14.6926C181.253 14.6066 181.263 14.4827 181.187 14.3883C181.123 14.308 180.988 14.2855 180.886 14.3376Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.685 14.5517V14.7179H174.857H175.03V14.5559C175.03 14.3686 175.055 14.3897 174.826 14.3883L174.685 14.3869V14.5517Z"
        fill="#C6B7FF"
      />
      <path
        d="M181.39 15.0194V15.0983H181.454C181.515 15.0983 181.517 15.0969 181.526 15.0504C181.543 14.9659 181.533 14.9504 181.457 14.9461L181.39 14.9419V15.0194Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.685 15.118V15.2814H174.857H175.03V15.1264V14.9715H174.88C174.798 14.9715 174.721 14.9672 174.708 14.963C174.688 14.956 174.685 14.9743 174.685 15.118Z"
        fill="#C6B7FF"
      />
      <path
        d="M172.661 15.8913C172.527 15.9786 172.521 16.1646 172.648 16.2575C172.748 16.3294 172.922 16.2885 172.978 16.1787C173.035 16.0688 172.988 15.9223 172.882 15.8786C172.809 15.849 172.715 15.8533 172.661 15.8913Z"
        fill="#C6B7FF"
      />
      <path
        d="M177.802 16.2449L177.742 16.3054L177.771 16.359C177.818 16.4463 177.824 16.5238 177.786 16.5984C177.769 16.6336 177.733 16.6787 177.706 16.6984L177.657 16.7351V17.3675V18H177.765H177.873V17.0914C177.873 16.5914 177.871 16.1829 177.868 16.1829C177.865 16.1829 177.837 16.211 177.802 16.2449Z"
        fill="#C6B7FF"
      />
      <path
        d="M177.502 16.4167C177.436 16.4618 177.478 16.5773 177.559 16.5773C177.597 16.5773 177.643 16.5266 177.643 16.4871C177.643 16.4533 177.584 16.3941 177.551 16.3941C177.542 16.3941 177.519 16.404 177.502 16.4167Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.076 16.8449V17.1407H173.385H173.692L173.696 16.8506C173.699 16.6914 173.698 16.5576 173.695 16.5548C173.692 16.5519 173.551 16.5491 173.382 16.5491H173.076V16.8449Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.39 16.6224C180.395 16.6632 180.399 16.797 180.399 16.9182V17.1407H180.706H181.015L181.019 16.8548C181.022 16.6984 181.022 16.566 181.019 16.559C181.016 16.5534 180.871 16.5491 180.698 16.5491H180.38L180.39 16.6224Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.269 17.538C173.274 17.5563 173.278 17.5915 173.278 17.6154C173.278 17.6619 173.278 17.6619 173.35 17.6619H173.422V17.5845V17.507H173.341C173.264 17.507 173.261 17.5084 173.269 17.538Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.701 17.5845V17.6619H180.773H180.845V17.5845V17.507H180.773H180.701V17.5845Z"
        fill="#C6B7FF"
      />
      <line
        x1="189"
        y1="12.5"
        x2="211"
        y2="12.5"
        stroke="url(#paint1_linear_2047_13392)"
      />
      <line
        y1="-0.5"
        x2="22"
        y2="-0.5"
        transform="matrix(-1 0 0 1 165 13)"
        stroke="url(#paint2_linear_2047_13392)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2047_13392"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(186 9) rotate(90) scale(11.6985)"
        >
          <stop stopColor="#3D2B7E" />
          <stop offset="1" stopColor="#0C0620" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2047_13392"
          x1="189"
          y1="13.5"
          x2="211"
          y2="13.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F5CFF" />
          <stop offset="1" stopColor="#0F0E10" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2047_13392"
          x1="0"
          y1="0.5"
          x2="22"
          y2="0.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F5CFF" />
          <stop offset="1" stopColor="#0F0E10" />
        </linearGradient>
      </defs>
    </svg>
  );
};
